export default "__VITE_ASSET__D_x9YT1E__"